import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  Label,
  Input,
} from "reactstrap"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"

import { Slide, toast, ToastContainer } from "react-toastify"
import { AvForm } from "availity-reactstrap-validation"
import FileDownload from "js-file-download"
import Select from "react-select"

const DataTableAvisOrientation = props => {
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [id, setId] = useState("")
  const [file, setFile] = useState(null)
  // Data Table
  const [orders, setOrders] = useState([])
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState("")
  const [specialite, setSpecialite] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    alwaysShowAllBtns: true,
    sizePerPage: 30,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  const addFile = e => {
    var file = e.target.files[0]
    setFile(file)
  }
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "specialite",
      text: props.t("Spécialite"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "titre",
      text: props.t("Titre"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "description",
      text: props.t("Description"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "id",
      isDummyField: true,
      text: "Téléchargement",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <a
          onClick={() => download2(row.id, row.titre)}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <i
            style={{ color: "#955cd5", cursor: "pointer" }}
            className="fas fa-file-download"
          ></i>
        </a>
      ),
    },
    {
      dataField: "Suppression",
      isDummyField: true,
      text: props.t("Suppression"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <i
            style={{ color: "#ED6464", cursor: "pointer" }}
            onClick={() => toggle(row.id)}
            className="fas fa-trash-alt"
          ></i>
        </div>
      ),
    },
  ]
  const download2 = async (id, titre) => {
    try {
      // On attend la réponse avec await
      const res = await API.post(
        "orientation/avis/download",
        {
          id: id,
          annee_id: annee_id,
        },
        { responseType: "blob" } // Important pour les fichiers binaires
      )

      // On télécharge le fichier avec le nom souhaité
      FileDownload(res.data, `${titre}.pdf`)
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error)
      toast.error("❌ Échec du téléchargement", { containerId: "A" })
    }
  }
  const { SearchBar } = Search
  useEffect(async () => {
    const resSpec = await API.post(
      "specialite_orientation/select_specialites_sources",
      {
        annee_id: annee_id,
      }
    ).then(resSpec => {
      setSpecialite(resSpec.data.specialites)
    })
    const res = await API.post("orientation/avis/list", { annee_id }).then(
      res => {
        setOrders(res.data.avis)
      }
    )
    setLoading(true)
  }, [])
  const toggle = id => {
    setModal(!modal)
    setId(id)
  }
  const toggleDelete = async () => {
    try {
      await API.post("orientation/avis/delete", {
        id,
        annee_id,
        user_id,
      })

      const resS = await API.post("orientation/avis/list", {
        annee_id,
      })

      console.log("resS =", resS)
      console.log("resS.data =", resS.data)

      if (resS.data && resS.data.avis) {
        setModal(false)
        setOrders(resS.data.avis)
      } else {
        console.error("Structure inattendue :", resS)
      }
    } catch (error) {
      console.error(error)
    }
  }
  // useEffect(() => {
  //   setModal(false)
  // }, [orders])
  const save = async () => {
    var pathFile = ""
    if (file != null) {
      pathFile = file.name
    }

    if (pathFile !== "") {
      const formData = new FormData()
      formData.append("fichier_pdf", file)
      formData.append("specialite_id", selectSpecialite.value)
      formData.append("annee_id", annee_id)
      formData.append("titre", title)
      formData.append("description", description)

      try {
        // ATTENTION ici: await pour récupérer la réponse
        const resA = await API.post("orientation/avis/store", formData)

        // Vérification que resA.data existe
        if (resA?.data?.errNum === 200 || resA?.data?.errNum === "200") {
          setSelectSpecialite("")
          setTitle("")
          setDescription("")
          toast.success("🔓✔️  Avis orientation ajouté Avec succès", {
            containerId: "A",
          })

          const res = await API.post("orientation/avis/list", { annee_id })
          setOrders(res.data.avis)
        }
      } catch (error) {
        console.error("Erreur lors de l'enregistrement :", error)
        toast.error("❌ Une erreur est survenue", { containerId: "A" })
      }
    }
  }
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Fragment>
            <AvForm>
              <Form>
                <Row>
                  <Col lg="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Spécialité :
                      </Label>
                      <Select
                        options={specialite}
                        value={selectSpecialite}
                        isSearchable={true}
                        isClearable={true}
                        onChange={e => setSelectSpecialite(e)}
                        placeholder={props.t("Select")}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Fichier :</Label>
                      <Input
                        onChange={e => addFile(e)}
                        className="form-control"
                        type="file"
                        id="formFile"
                        accept=".pdf"
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Titre :</Label>
                      <Input
                        lg="3"
                        className="form-control"
                        placeholder="Titre"
                        type="text"
                        value={title}
                        onChange={e => setTitle(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Description :
                      </Label>
                      <Input
                        value={description}
                        lg="3"
                        className="form-control"
                        placeholder="Description ..."
                        type="textarea"
                        onChange={e => setDescription(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
              </Form>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Col lg="6">
                  <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-primary "
                      onClick={save}
                    >
                      {props.t("Confirmer")}
                    </button>
                  </div>
                </Col>
              </div>
            </AvForm>
            <Row className="mt-4">
              <Col xs="12">
                <ToolkitProvider
                  keyField="id"
                  data={orders}
                  columns={Columns()}
                  search
                  bootstrap4
                >
                  {toolkitProps => (
                    <div>
                      <div>
                        <div className="mb-3 row" style={{ display: "flex" }}>
                          <div className="col-md-6 mb-3 row">
                            <div className="col-md-8 search-box-etd">
                              <div
                                className="search-box me-2 mb-2 d-inline-block"
                                style={{ width: "100%" }}
                              >
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <BootstrapTable
                        wrapperClasses="table-responsive"
                        noDataIndication={() => <NoDataIndication />}
                        striped={false}
                        bordered={false}
                        classes={"table align-middle table-nowrap"}
                        headerWrapperClasses={"table-light"}
                        hover
                        pagination={paginationFactory(pageOptions)}
                        {...toolkitProps.baseProps}
                      />
                    </div>
                  )}
                </ToolkitProvider>
              </Col>
            </Row>
          </Fragment>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement")} ...{" "}
            </h4>
          </div>
        )}
      </div>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {props.t("Suppression")} {props.t("d'avis orientation")}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>{props.t("Voulez-vous supprimer cette avis ?")}</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDelete}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {props.t("Oui")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Non")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableAvisOrientation))
DataTableAvisOrientation.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}
